export default __webpack_public_path__ + "static/media/svnit.969bd358.webp";